export default __webpack_public_path__ + "static/hari1-e1f1b1cda90a1aefc428c260d0995ef9.jpg";